import * as Yup from 'yup';

export const historyModalSchema = Yup.object().shape({
  comment: Yup.string().required('Comentário obrigatório')
});
